import { ChevronRight } from "@/public/icons/ChevronRight";
import { Category } from "../category/Category";
import styles from "./CarrouselSelectorDesktop.module.scss";
import { CarrouselProps } from "../carrousel/Carrousel";

export type CarrouselSelectorDesktopProps = {
  carrousel: CarrouselProps[];
  carrouselSelected: CarrouselProps;
  carrouselSelectedIndex: number;
  setCarrouselSelectedIndex: (index: number) => void;
  setCarrouselSelected: (carrousel: CarrouselProps) => void;
};

export const CarrouselSelectorDesktop = ({
  carrousel,
  carrouselSelected,
  carrouselSelectedIndex,
  setCarrouselSelected,
  setCarrouselSelectedIndex,
}: CarrouselSelectorDesktopProps) => {
  const carrouselLastIndex = carrousel.length - 1;

  const changeCategory = (isNext: boolean) => {
    if (
      (isNext && carrouselSelectedIndex === carrouselLastIndex) ||
      (!isNext && carrouselSelectedIndex === 0)
    ) {
      return;
    }
    const nextIndex = isNext
      ? carrouselSelectedIndex + 1
      : carrouselSelectedIndex - 1;
    setCarrouselSelectedIndex(nextIndex);
    setCarrouselSelected(carrousel[nextIndex]);
  };

  return (
    <div className={styles.category}>
      <div
        className={`${styles.chevronLeft} ${
          carrouselSelectedIndex === 0 ? styles.disabled : ""
        }`}
        onClick={() => changeCategory(false)}
      >
        {carrouselSelectedIndex !== 0 && <ChevronRight />}
      </div>

      <Category
        title={carrouselSelected.title}
        subTitle={carrouselSelected.subTitle}
      />

      <div
        className={`${styles.chevronRight} ${
          carrouselSelectedIndex === carrouselLastIndex ? styles.disabled : ""
        }`}
        onClick={() => changeCategory(true)}
      >
        {carrouselSelectedIndex !== carrouselLastIndex && <ChevronRight />}
      </div>
    </div>
  );
};
